var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.6988 0C2.05944 0 1.44626 0.253985 0.994168 0.706082C0.542071 1.15818 0.288086 1.77135 0.288086 2.41071V2.89286H15.7141V2.41071C15.7141 1.77135 15.4601 1.15818 15.008 0.706082C14.5559 0.253985 13.9427 0 13.3034 0H2.69944H2.6988ZM0.288086 9.16071V3.85714H15.7141V9.16071C15.7141 9.80008 15.4601 10.4133 15.008 10.8653C14.5559 11.3174 13.9427 11.5714 13.3034 11.5714H2.69944C2.06008 11.5714 1.44691 11.3174 0.994811 10.8653C0.542714 10.4133 0.288729 9.80008 0.288729 9.16071H0.288086ZM10.7319 7.39286C10.6041 7.39286 10.4814 7.44365 10.391 7.53407C10.3006 7.62449 10.2498 7.74713 10.2498 7.875C10.2498 8.00287 10.3006 8.12551 10.391 8.21593C10.4814 8.30635 10.6041 8.35714 10.7319 8.35714H12.9819C13.1098 8.35714 13.2325 8.30635 13.3229 8.21593C13.4133 8.12551 13.4641 8.00287 13.4641 7.875C13.4641 7.74713 13.4133 7.62449 13.3229 7.53407C13.2325 7.44365 13.1098 7.39286 12.9819 7.39286H10.7319Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccIcon);
export default __webpack_public_path__ + "static/media/accIcon.6032c3dce5e33b54b4ec6b837ca52d2a.svg";
export { ForwardRef as ReactComponent };